<template>
  <div>
    <div class="tw-bg-white tw-shadow tw-border-t tw-border-gray-200">
      <base-content class="tw-pt-3 tw-pb-3.5">
        <base-breadcrumbs :breadcrumbs="breadcrumbs" />
      </base-content>
      <base-content class="tw-pt-0 tw-flex tw-items-center tw-justify-between">
        <h1 class="tw-text-xl sm:tw-text-2xl tw-leading-tight tw-text-gray-900 tw-mb-0 tw-font-thin">Credit Card Readers</h1>
        <base-button @click="register"
          ><template v-slot:icon>
            <plus-icon /> </template
          >Add New Reader</base-button
        >
      </base-content>
    </div>
    <base-content>
      <base-table :loading="isLoading" :fields="fields" :items="items" class="tw-mt-5">
        <template #label="{item: reader}">
          <div class="tw-flex tw-items-center">
            {{ reader.label }}
          </div>
        </template>
        <template #businessLocationName="{item: reader}">
          <div>{{ reader.businessLocationName }}</div>
        </template>
        <template #serialNumber="{item: reader}">
          <div>{{ reader.serialNumber }}</div>
        </template>
        <template #actions="{item: reader}">
          <div class="tw-flex tw-items-center tw-space-x-2">
            <base-button type="flat" @click="edit(reader)">
              <template v-slot:icon>
                <edit-icon /> </template
              >Edit
            </base-button>
            <base-button type="flat" @click="del(reader)">
              <template v-slot:icon>
                <trash-icon /> </template
              >Delete
            </base-button>
          </div>
        </template>
        <template #empty-state>
          <div class="tw-flex tw-justify-center tw-py-5">
            No Results
          </div>
        </template>
        <template #loading-row>
          <td class="tw-py-3 tw-px-4">
            <base-skeleton-loader class="tw-h-4 tw-w-24 tw-mb-2" />
          </td>
          <td class="tw-py-3 tw-px-4">
            <base-skeleton-loader class="tw-h-4 tw-w-24 tw-mb-2" />
          </td>
          <td class="tw-py-3 tw-px-4">
            <base-skeleton-loader class="tw-h-4 tw-w-24 tw-mb-2" />
          </td>
          <td class="tw-py-3 tw-px-4">
            <div class="tw-flex tw-justify-between tw-gap-3">
              <base-skeleton-loader class="tw-h-6 tw-w-16" />
              <base-skeleton-loader class="tw-h-6 tw-w-16" />
            </div>
          </td>
        </template>
      </base-table>
      <base-pagination v-model="page" class="tw-mt-2" />
    </base-content>
    <business-card-reader-registration :businessId="businessId" ref="registerCardReader" @save="loadPage"></business-card-reader-registration>
    <business-card-reader-delete ref="deleteConfirmationModal" @delete="loadPage"></business-card-reader-delete>
    <BusinessCardReaderEdit ref="editModal" @edit="loadPage"></BusinessCardReaderEdit>
  </div>
</template>

<script>
import { PlusIcon, EditIcon, TrashIcon } from "@/assets/svgs";
import BusinessCardReaderRegistration from "@/views/business/card-readers/components/BusinessCardReaderRegistration.vue";
import BusinessCardReaderDelete from "@/views/business/card-readers/components/BusinessCardReaderDelete.vue";
import BusinessCardReaderEdit from "@/views/business/card-readers/components/BusinessCardReaderEdit.vue";

export default {
  name: "BusinessCardReaders",
  components: {
    BusinessCardReaderRegistration,
    BusinessCardReaderDelete,
    BusinessCardReaderEdit,
    PlusIcon,
    EditIcon,
    TrashIcon,
  },
  props: {
    businessId: String,
  },
  data() {
    return {
      isLoading: false,
      items: [],
      fields: [
        { title: "Reader", key: "label", thClass: "" },
        { title: "Location", key: "businessLocationName", thClass: "" },
        { title: "Serial Number", key: "serialNumber", thClass: "" },
        { title: "Actions", key: "actions", thClass: "tw-w-0 tw-text-center" },
      ],
      page: {
        take: 10,
        skip: 0,
        total: 0,
      },
    };
  },
  watch: {
    page() {
      this.loadPage();
    },
  },
  computed: {
    breadcrumbs() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return [{ title: "Settings", onClick: () => this.$router.push(`/businesses/${this.businessId}/business`) }, { title: "Credit Card Readers" }];
    },
  },
  mounted() {
    this.loadPage();
  },
  methods: {
    loadPage() {
      this.isLoading = true;
      let url = `/businesses/${this.businessId}/cardreaders`;
      url += `?skip=${this.page.skip}&take=${this.page.take}`;

      this.$axios
        .get(url)
        .then((res) => {
          this.items = res.data.items;
          this.page.total = res.data.total;
        })
        .catch((err) => {
          this.EventBus.$emit("GLOBAL_ERROR", { title: "Error loading card readers", message: err.message, error: err });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    next() {
      this.page.skip += this.page.take;
    },
    previous() {
      this.page.skip -= this.page.take;
    },
    edit(item) {
      this.$refs.editModal.show(this.businessId, item.stripeReaderId, item.label);
    },
    del(item) {
      this.$refs.deleteConfirmationModal.show(this.businessId, item.stripeReaderId);
    },
    register() {
      this.$refs.registerCardReader.show();
    },
  },
};
</script>
